<template>
  <SogCard class="sog-card">
    <SogCardTitle>
      Schnittstelle
    </SogCardTitle>
    <SogCardContent>
      <table>
        <tr>
          <td>Schedule</td>
          <td>
            <SogScheduleSerieLabel
              :value="details?.getValue(PersonDetailsId.ExternalInterfaceExportSchedule)"
            />
          </td>
        </tr>

        <tr>
          <td>Nächster Export</td>
          <td>
            <SogDataLabel
              :value="details?.getValue(PersonDetailsId.ExternalInterfaceExportNext)"
              :value-type="SogDataLabelValueType.DateTime"
            />
          </td>
        </tr>
      </table>
    </SogCardContent>

    <SogCardActions>
      <SogCardActionButton @click="onExportNow">
        Jetzt exportieren
      </SogCardActionButton>
    </SogCardActions>
  </SogCard>
</template>


<script setup lang="ts">
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import PersonDetailsId from "@/shared/model/personDetailsId";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import PersonDetails from "@/shared/model/personDetails";
import Address from "@/shared/model/Address";
import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import SogScheduleSerieLabel from "@/shared/ui/SogScheduleSerie/SogScheduleSerieLabel.vue";

interface Props {
  details?: PersonDetails
}

const props = withDefaults(defineProps<Props>(), {
      details: undefined
    }
)

const _emit = defineEmits([ 'updated'])

function onExportNow() {
  _emit('updated');
}

// async function onExportNow() {
//   if (!_details || !_person.value?.id) return;
//
//   _spinner.show();
//   try {
//     const success = await apiOrganisationStructure.updateDetails(
//         _accountStore.person?.id, _person.value?.id, _details.getValues()
//     );
//
//     if (success) {
//       await p_init(_route);
//     }
//   } finally {
//     _spinner.hide();
//   }
// }




</script>
